module.exports = __webpack_public_path__ + "static/media/19ESCAP36.2141fb6f.jpg";